import { format, parseISO } from 'date-fns';
import { SnackbarMessageVariants } from '../../../../helpers/enums';
import { enqueueSnackbar } from '../../notificationActions';
import { SubscriptionStatus } from '../../../../interfaces/truckLoadRateServiceInterfaces';
import ApiService from '../../../../services/apiService';
import Endpoints from '../../../../services/endpoints';

export const RECEIVE_SUBSCRIPTION_STATUS = 'RECEIVE_SUBSCRIPTION_STATUS';
export const REQUEST_SUBSCRIPTION_STATUS_FAILED = 'REQUEST_SUBSCRIPTION_STATUS_FAILED';
export const REQUEST_SUBSCRIPTION_STATUS = 'REQUEST_SUBSCRIPTION_STATUS';

const requestSubscriptionStatus = (): object => {
    return {
        type: REQUEST_SUBSCRIPTION_STATUS
    };
};

const requestSubscriptionCancelationFailed = (): object => {
    return {
        type: REQUEST_SUBSCRIPTION_STATUS_FAILED
    };
};

const receiveSubscriptionStatus = (response: SubscriptionStatus): object => {
    return {
        type: RECEIVE_SUBSCRIPTION_STATUS,
        payload: response
    };
};

export const fetchSubscriptionStatus = (): object => {
    return async (dispatch: Function): Promise<void> => {
        dispatch(requestSubscriptionStatus());

        try {
            const subscriptionStatus: SubscriptionStatus = await ApiService.get(Endpoints.tlrSubscriptionStatusEndPoint, true);
            dispatch(receiveSubscriptionStatus(subscriptionStatus));
        } catch (err) {
            dispatch(requestSubscriptionCancelationFailed());
            dispatch(enqueueSnackbar({
                message: 'Error occurred while fetching Account Information',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};

const isBeforeBillingDate = (billingDate: Date, todaysDate: Date): boolean => {
    billingDate.setHours(0, 0, 0, 0);
    todaysDate.setHours(0, 0, 0, 0);
    return todaysDate < billingDate;
};

const subscriptionUpdateResponseMessage = (cancelAutoPay: boolean, subscriptionStatusResponse: SubscriptionStatus): string => {
    let message = '';
    const isBeforeBilling = isBeforeBillingDate(
        new Date(format(parseISO(subscriptionStatusResponse.nextBillingDate.toString()), 'MM/dd/yyyy')), new Date()
    );
    const billingDate = new Date(subscriptionStatusResponse.nextBillingDate).toLocaleDateString();
    if (cancelAutoPay && subscriptionStatusResponse.autoPayCanceled) {
        if (isBeforeBilling) {
            message = `Subscription was successfully canceled, you can continue to use your account until ${billingDate}`;
        } else {
            message = 'Subscription was succussfully canceled, the account will be deactivated tomorrow';
        }
    } else if (!cancelAutoPay && !subscriptionStatusResponse.autoPayCanceled) {
        if (isBeforeBilling) {
            message = `Subscription successfully re-enabled. The account subscription will automatically renew on ${billingDate}`;
        } else {
            message = 'Subscription successfully re-enabled. The account subscription will automatically renew tomorrow';
        }
    }
    return message;
};

export const toggleSubscription = (cancelAutoPay: boolean): object => {
    return async (dispatch: Function): Promise<void> => {
        try {
            const body = {
                cancelAutoPay
            };
            dispatch(requestSubscriptionStatus());
            const subscriptionStatus: SubscriptionStatus = await ApiService.post(Endpoints.tlrSubscriptionStatusEndPoint, body, true);
            dispatch(receiveSubscriptionStatus(subscriptionStatus));
            const responseMessage = subscriptionUpdateResponseMessage(cancelAutoPay, subscriptionStatus);
            dispatch(enqueueSnackbar({
                message: responseMessage,
                variant: SnackbarMessageVariants.Success
            }));
        } catch (err) {
            dispatch(requestSubscriptionCancelationFailed());
            dispatch(enqueueSnackbar({
                message: 'Error occurred while updating Subscription Status',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};
